import React from "react";
import { DocumentCard,
    DocumentCardDetails,
    DocumentCardTitle,
    DocumentCardActivity,
    DocumentCardLocation } from '@fluentui/react';
import {ApproverDialog} from "./ApproverDialog";
import { PowerAppSolutionChangeTaskType } from '../../GlobalConst/globalEnums';
import { renderDateTime, renderUser } from "../../helpers/HelperMethods";
import Api from '../../services/Api'
import PowerAppOwnerChange from "./ChangeValues/PowerAppOwnerChange";
import PowerAppRecertificationTask from "./ChangeValues/PowerAppRecertificationTask";
import DeletePowerAppSolutionDialogContent from "../EditSite/PowerAppEditElements/DeletePowerAppSolutionDialogContent";
import PowerAppDeleteTask from "./ChangeValues/PowerAppDeleteTask";

const PowerAppSolutionChangeTask = ({change, refresh, getCallback}) => {

    const mapOwnerForPeople = (user) => {
        return user ? [{ name: user.displayName }] : [];
    }

    const onLocationClick = (e) => {
        e.stopPropagation();
        e.preventDefault();

        window.open(e.target.href, '_blank');
    }

    const getTitle = (taskType) => {
        switch (taskType) {
            case PowerAppSolutionChangeTaskType.primaryOwner:
            case PowerAppSolutionChangeTaskType.secondaryOwner:
                return 'Owner change'
            case PowerAppSolutionChangeTaskType.recertification:
                return 'Recertification'
            case PowerAppSolutionChangeTaskType.technicalOwner:
                return 'Technical Owner change'
            case PowerAppSolutionChangeTaskType.delete:
                return 'Deletion request'
            default:
                return null
        }
    }

    const getChangeDetails = (change) => {
        switch (change.type) {
            case PowerAppSolutionChangeTaskType.primaryOwner:
            case PowerAppSolutionChangeTaskType.secondaryOwner:
            case PowerAppSolutionChangeTaskType.technicalOwner:
                return <PowerAppOwnerChange currentOwner={change.currentValue} newOwner={change.changeValue}/>
            case PowerAppSolutionChangeTaskType.recertification:
                return <PowerAppRecertificationTask solution={change.solution} task={change} getCallback={getCallback} refresh={refresh} />
            case PowerAppSolutionChangeTaskType.delete:
                return <PowerAppDeleteTask app={change.solution} />
            default:
                return null
        }
    }

    const getDialogTitle = (type) => {
        switch (type) {
            case PowerAppSolutionChangeTaskType.primaryOwner:
            case PowerAppSolutionChangeTaskType.secondaryOwner:
            case PowerAppSolutionChangeTaskType.technicalOwner:
                return "Approve or reject ownership change"
            case PowerAppSolutionChangeTaskType.recertification:
                return "Recertification todo"
            case PowerAppSolutionChangeTaskType.delete:
                return "Approve or reject deletion request"
            default:
                return null
        }
    }

    const getObjectType = () => {
        return  <div style={objectTypeStyles}>Solution</div>
    }

    const onReject = (comment) => {
        const url = '/RejectPowerAppSolutionChange'
        postDecision({comment}, url);
    }

    const onApprove = (approveObject) => {
        const url = '/ApprovePowerAppSolutionChange';
        postDecision(approveObject, url);
    }

    const postDecision = (approveObject, urlPart) => {
        const post = {
            id: change.id,
            ...approveObject
        };

        Api.post(urlPart, post)
            .then(res => res.data)
            .then(post => {
                    if (post === 200) {
                        refresh();
                    } else {
                        console.log("Update failed")
                    }
                }
            ).catch((error) => {
            console.log(error)})
    }
    
    const powerAppLogo = <span className='cardLogo powerAppLogo' />
    const flowLogo = <span className='cardLogo flowLogo' />

    
    const getDialogMessage = (task) => {
        switch (task.type) {
            case PowerAppSolutionChangeTaskType.primaryOwner:
            case PowerAppSolutionChangeTaskType.secondaryOwner:
            case PowerAppSolutionChangeTaskType.technicalOwner:
                return change.additionalData === 'True'
                    ? <div>The current owner has requested that ownership be updated <b>only</b> in the Provisioner database. This means that once the transfer is approved, you will <b>not</b> automatically receive access to the artifacts.</div>
                    : <div>The current owner has requested that ownership be updated in <b>both</b> the Provisioner tool and the Power Platform environments. This means that upon approval, you will be granted access to the artifacts in the Power Platform environments.</div>
            case PowerAppSolutionChangeTaskType.delete:
                return  <div>
                            <div style={{marginBottom: 20}}>Deletion of "{task.solution.name}" {task.solution.type} has been requested by {renderUser(task.createdBy)}.</div>
                            {
                                task.solution.groupedSolutions.map((s, index) => <DeletePowerAppSolutionDialogContent solution={s} key={index} />)
                            }
                        </div>
            default:
                return null
        }
    }

    return (
        <div>
            <DocumentCard styles={cardStyles} >
                <DocumentCardDetails styles={detailsStyles} >
                    <div style={headerStyles}>
                        {powerAppLogo}
                        {flowLogo}
                        <div style={titleStyles}>
                            <DocumentCardTitle title={getTitle(change.type)} shouldTruncate={false} styles={cardTitleStyles} />
                            {
                                getObjectType()
                            }
                        </div>
                    </div>
                    <DocumentCardLocation 
                        styles={urlStyles} 
                        location={change.solution.name} 
                        locationHref={change.solution.url} 
                        onClick={onLocationClick} 
                        title={change.solution.name} 
                    />
                    {
                        getChangeDetails(change)
                    }
                </DocumentCardDetails>
                {
                    change.type !== PowerAppSolutionChangeTaskType.recertification &&
                    <div>
                        <div style={createdByStyles}>
                            <div>Change requested by: </div>
                            <DocumentCardActivity
                                activity={`Created on ${renderDateTime(change.requestDate)}`}
                                people={mapOwnerForPeople(change.createdBy)}
                            />
                        </div>
                        <div style={iconContainerStyles}> 
                                <ApproverDialog
                                    buttonName={"Decision"}
                                    title={getDialogTitle(change.type)}
                                    onReject={onReject}
                                    onApprove={onApprove}
                                    additionalInfo={getDialogMessage(change)}
                                />
                        </div>
                    </div>
                }
            </DocumentCard>
        </div>
    );
}

const urlStyles = {
    root: {
        color: 'rgb(0, 120, 212)',
        fontSize: '14px',
        // fontWeight: 'bold',
        whiteSpace: 'nowrap',
        overflowWrap: 'break-word',
        padding: '20px 12px',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    }
}

const createdByStyles = {
    padding: '8px',
    fontSize: '12px',
    flex: 1
}

const iconContainerStyles = {
    display: 'flex',
    flexDirection: 'column'
}
const titleStyles = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    maxHeight: '35px',
    alignItems: 'baseline',
    flex: 1
}

const cardStyles = {
    root: {
        marginRight: 20,
        marginBottom: 20,
        width: 400,
        height: 300,
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid',
    }
}

const detailsStyles = {
    root: {
        height: 235,
        flex: 5,
        justifyContent: 'start'
    }
}

const objectTypeStyles = {
    padding: '8px 16px 8px 8px',
    fontSize: 14,
    textAlign: 'right'
}

const headerStyles = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
}

const cardTitleStyles = {
    root: {
        padding: '8px',
        minWidth: '145px'
    }
}

export default PowerAppSolutionChangeTask


// WEBPACK FOOTER //
// ./src/components/ManageCenter/PowerAppSolutionChangeTask.js